<template>
  <div>
    <sub-head subTitle="기능성 게임" subImg="game_top" class="web"></sub-head>
    <sub-head subTitle="기능성 게임" class="mobile"></sub-head>

    <div class="page_padding">
      <bread-crumb :path="$route"></bread-crumb>
    </div>
    <game-modal
      v-show="showModal"
      v-on:close="closeModal"
      :modalItem="modalInfo"
      ref="gameModal"
    ></game-modal>
    <div class="page_padding">
      <div class="paddingTB">
        <tab
          :tabList="tabList"
          @active-tab="setActiveTab"
          :index="parseInt(index)"
        ></tab>
        <div class="game-list-wrapper">
          <div
            v-for="(item, info) in filtering_game(game_kind, is_all)"
            :key="info"
            class="item"
            v-on:click="game_detail(item)"
          >
            <div @click="openModal" class="game-block-wrapper">
              <image-component
                :is_jpg="false"
                :name="item.game"
                path="icons"
              ></image-component>
              <div>
                <span class="font20 fontExtraBold text333">
                  {{ item.game_kor }}
                </span>
              </div>
              <div class="title text333">
                <span>{{ item.game_eng }}</span>
              </div>
              <!-- <div
                  class="textWhite d-flex borderRadius justify-content-center paddingTB1 game_property"
                >
                  <div :class="{[item.game_kind]: true}" class="kind">
                    <span class="font14">{{ item.game_kind }}</span>
                  </div>
                  <div class="player">
                    <span class="font14">{{ item.player }}</span>
                  </div>
                </div> -->
            </div>
            <game-info-badge
              :gameInfo="{kind: item.game_kind, player: item.player}"
            ></game-info-badge>
            <!-- 경쟁, 2 ~ 4인용 컴포넌트로 빼서 모달에도 끼기 -->
            <!-- <div class="game-info-wrapper">
              <div class="info-item" :class="{[item.game_kind]: true}">
                <span>{{ item.game_kind }}</span>
              </div>
              <div class="info-item"><span>2-4인용</span></div>
            </div> -->
          </div>
          <div
            class="item hidden"
            v-for="item in game_count()"
            :key="item"
          ></div>
        </div>
        <button
          href="#"
          class="show_more_btn"
          @click="showAll()"
          v-show="this.game_info.length > this.showing_count"
        >
          {{ button_value }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import subTopContents from "../../assets/source/json/sub_top.json";
import gameContents from "../../assets/source/json/game_info.json";
import subHead from "../../components/sub_head.vue";
import ImageComponent from "../../components/imageComponent.vue";
import GameModal from "../../components/modal/GameModal.vue";
import Tab from "../../components/Tab.vue";
import GameInfoBadge from "../../components/GameInfoBadge.vue";
import BreadCrumb from "../../components/BreadCrumb.vue";
export default {
  components: {
    subHead,
    ImageComponent,
    GameModal,
    Tab,
    GameInfoBadge,
    BreadCrumb,
  },
  props: ["game_name"],
  data() {
    return {
      content: subTopContents,
      all_game_info: gameContents,
      game_info: gameContents,
      is_true: false,
      game_kind: "all",
      isShowAll: false,
      is_all: "",
      button_value: "더보기",
      is_moreshow: true,
      showing_count: 12,
      showModal: false,
      modalInfo: {
        game: "GAME_BALLOON",
        game_eng: "",
        game_kor: "",
        game_kind: "",
        player: "",
        text: "",
      },
      tabList: ["전체", "협동", "경쟁", "힐링", "학습"],
    };
  },
  computed: {
    index() {
      return this.$route.query.index || 0;
    },
  },
  methods: {
    game_detail(item) {
      this.is_true = true;
      this.showModal = true;
      this.modalInfo.game = item.game;
      this.modalInfo.game_eng = item.game_eng;
      this.modalInfo.game_kor = item.game_kor;
      this.modalInfo.game_kind = item.game_kind;
      this.modalInfo.player = item.player;
      this.modalInfo.text = item.text;
      return this.modalInfo;
    },
    game_count() {
      let gameCount = Object.keys(this.game_info).length;
      let empty_box = [];
      let hiddenCount = 0;
      if (gameCount % 4 != 0) {
        hiddenCount = 4 - (gameCount % 4);
      }
      for (let i = 0; i < hiddenCount; i++) {
        empty_box[i] = "empty" + i;
      }
      return empty_box;
    },
    showAll() {
      if (!this.isShowAll) {
        this.isShowAll = true;
        this.is_all = "all";
        this.button_value = "접기";
        return;
      }
      this.isShowAll = false;
      this.is_all = "";
      this.button_value = "더보기";
    },
    filtering_game: function(kind, more) {
      let gameList = this.game_info;

      // 게임 종류 필터링
      if (kind !== "all") {
        gameList = this.game_info.filter(function(content) {
          return content.game_kind === kind;
        });
      }
      // 전체 보기 or 필터링
      if (more !== "all") {
        return gameList.slice(0, this.showing_count);
      }
      return gameList;
    },
    filter_game_kind(kind) {
      this.game_kind = kind;
      this.game_info = [];
      if (this.game_kind == "all") {
        this.game_info = this.all_game_info;
      } else {
        for (var i = 0; i < this.all_game_info.length; i++) {
          if (this.all_game_info[i].game_kind == this.game_kind) {
            this.game_info.push(this.all_game_info[i]);
          }
        }
      }
      this.isShowAll = false;
      this.is_all = "";
      this.button_value = "더보기";
    },
    openModal() {
      document.querySelector("#app").style.overflow = "hidden";
      this.showModal = true;
    },
    closeModal() {
      document.getElementById("gameModal").scrollTop = 0;
      this.showModal = false;
      document.querySelector("#app").style.removeProperty("overflow");
    },
    openSlideModal(game_name) {
      for (var i = 0; i < this.all_game_info.length; i++) {
        if (game_name == this.all_game_info[i].game) {
          this.game_detail(this.all_game_info[i]);
        }
      }
    },
    setActiveTab(index) {
      index = parseInt(index);
      this.game_kind = index === 0 ? "all" : this.tabList[index];
      this.game_info = [];
      if (index === 0) {
        this.game_info = this.all_game_info;
      } else {
        for (var i = 0; i < this.all_game_info.length; i++) {
          if (this.all_game_info[i].game_kind == this.game_kind) {
            this.game_info.push(this.all_game_info[i]);
          }
        }
      }
      this.isShowAll = false;
      this.is_all = "";
      this.button_value = "더보기";
    },
  },

  mounted() {
    this.setActiveTab(this.index);
    if (this.game_name != "") {
      this.openSlideModal(this.game_name);
    }
  },

  watch: {
    $route() {
      let index = this.index;
      this.setActiveTab(index);
    },
  },
};
</script>

<style scoped>
.mobile {
  display: none;
}
ul li {
  list-style: none;
  border-right: 1px solid #e6e6e6;
  width: 25%;
  padding: 1.5rem 0;
  background-color: #f4f4f4;
  color: #333;
  font-size: 1.1rem;
}
ul li:last-child {
  border-right: 0px solid gray;
}

ul {
  display: flex;
  width: 100%;
  /* border: 1px solid gray; */
}
.padding0-8 {
  padding: 0.8rem 0;
}
.imgWrap img {
  width: 100%;
}
.modal_imgWrap {
  max-width: 180px;
  max-height: 180px;
}
.modal_imgWrap img {
  border-radius: 0 !important;
}
.game-list-wrapper {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 1rem 0;
}
.game-list-wrapper .item {
  width: 24%;
  min-width: 160px;
  padding: 1.8rem 0 3.2rem 0;
  border: 1px solid #d4d3d3;
  margin: 1rem 0;
}

/* .item:hover {
  cursor: pointer;
  border: 1px solid #f83f1b;
  box-shadow: 0 0 0 1px #f82f1b inset;
} */
.item.hidden {
  border: none;
  box-shadow: none;
  cursor: unset;
  margin: 0;
}
.active {
  background-color: #f83f1b;
  border-color: #f83f1b !important;
  color: white;
}

.kind,
.player {
  padding: 0.2rem 1rem;
  border-radius: 10px;
}
.kind {
  margin-right: 10px;
}
.player {
  background-color: #2b2e35;
}
.bgBackground {
  background-color: #e6e6e6;
}
.borderRadius {
  border-radius: 28px;
}
.overflowAuto {
  overflow: auto;
}
.game-block-wrapper {
  word-break: keep-all;
  height: calc(100% - 40px);
  padding: 0 24%;
  line-height: 1;
}
.game-block-wrapper .title {
  margin-bottom: 1.4rem;
}
.game-info-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
.info-item {
  padding: 0 10px;
  border-radius: 50px;
  border: 1px solid grey;
}
.info-item:nth-child(1) {
  margin-right: 5px;
}
.info-item span {
  font: 12px/20px paybooc;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 767px) {
  .banner.web {
    margin-top: 60px;
    .banner-title {
      font-size: 1.5rem;
    }
  }
}
</style>
